
<kendo-dialog *ngIf="active"
              class="isg-dialog-editor"
              (close)="closeForm()"
              [height]="(afUiWin.calculatedHeightLarge | async)!"
              [width]="(afUiWin.calculatedWidthMedium | async)!">
  <kendo-dialog-titlebar>
    {{ isNew ? "Add New License" : "Edit License" }}
  </kendo-dialog-titlebar>
  <form novalidate class="k-form" [formGroup]="editForm">

    <kendo-tabstrip [keepTabContent]="true">

      <kendo-tabstrip-tab [title]="'Main Settings'" [selected]="true">
        <ng-template kendoTabContent>

          <div class="isg-lic-editor-layout-main">

            <!--license name-->
            <kendo-formfield>
              <kendo-label [for]="name" text="License Name"></kendo-label>
              <kendo-textbox #name
                             formControlName="name"
                             required></kendo-textbox>
              <kendo-formerror>Error: license name is required</kendo-formerror>
            </kendo-formfield>

            <!--company-->
            <kendo-formfield>
              <kendo-label [for]="companyId" text="Select Company"></kendo-label>
              <kendo-dropdownlist #companyId
                                  formControlName="companyId"
                                  valueField="id"
                                  textField="name"
                                  [data]="companies"
                                  [defaultItem]="{ name: 'Select company', id: null }"
                                  [valuePrimitive]="true"
                                  style="width:100%;"
                                  required>
              </kendo-dropdownlist>
            </kendo-formfield>

            <!--license active-->
            <kendo-formfield>
              <isg-tri-state-checkbox #isActive
                                      formControlName="isActive"
                                      [nullable]="false"
                                      [textTrue]="'License Active'"
                                      [textFalse]="'License Inactive'"
                                      [ngClass]="{'isg-isActive': editForm.controls.isActive.value}"
                                      [isDisabled]="isReadOnlyCustomControl">
              </isg-tri-state-checkbox>
            </kendo-formfield>

            <!--start date-->
            <kendo-formfield>
              <kendo-label [for]="startDate" text="Start Date"></kendo-label>
              <kendo-datepicker #startDate
                                formControlName="startDate"
                                format="dd MMM yyyy">
              </kendo-datepicker>
            </kendo-formfield>

            <!--end date-->
            <kendo-formfield>
              <kendo-label [for]="endDate" text="End Date"></kendo-label>
              <kendo-datepicker #endDate
                                formControlName="endDate"
                                format="dd MMM yyyy">
              </kendo-datepicker>
            </kendo-formfield>

            <!--enforce end date-->
            <kendo-formfield>
              <isg-tri-state-checkbox #enforceEndDate
                                      formControlName="enforceEndDate"
                                      [nullable]="false"
                                      [textTrue]="'Access Blocked After End Date'"
                                      [textFalse]="'Accessible After End Date'"
                                      [isDisabled]="isReadOnlyCustomControl">
              </isg-tri-state-checkbox>
            </kendo-formfield>

            <!--max users-->
            <kendo-formfield>
              <kendo-label [for]="maxUsers" text="Max Users"></kendo-label>
              <kendo-numerictextbox #maxUsers
                                    formControlName="maxUsers"
                                    [style.width.px]="170"
                                    [decimals]="0"
                                    [format]="'n'">
              </kendo-numerictextbox>
            </kendo-formfield>

            <!--enforce users-->
            <kendo-formfield>
              <isg-tri-state-checkbox #enforceUsers
                                      formControlName="enforceUsers"
                                      [nullable]="false"
                                      [textTrue]="'User Count Enforced'"
                                      [textFalse]="'User Count Is Not Enforced'"
                                      [isDisabled]="isReadOnlyCustomControl"
                                      [style.width.px]="220"
                                      [style.display]="'block'">
              </isg-tri-state-checkbox>
            </kendo-formfield>

            <!--module-->
            <kendo-formfield class="moduleFormField">
              <kendo-label text="Select Module"></kendo-label>

              <div class="listViewFlex">
                <div *ngFor="let data of modules">
                  <input #moduleId type="checkbox" [checked]="data.licenseModuleID!=null"> {{data.name}}<br>
                </div>
              </div>
            </kendo-formfield>

            <!--home page-->
            <kendo-formfield>
              <kendo-label [for]="homePage" text="Home page"></kendo-label>
              <kendo-textbox #homePage
                             formControlName="homePage"></kendo-textbox>
            </kendo-formfield>

            <!--description-->
            <kendo-formfield>
              <kendo-label [for]="description" text="Description"></kendo-label>
              <kendo-textarea #description
                              formControlName="description"></kendo-textarea>

            </kendo-formfield>

          </div>
        </ng-template>
      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab [title]="'OneSys Settings'" *ngIf="showOneSysSettings">
        <ng-template kendoTabContent>

          <kendo-formfield>
            <kendo-label [for]="osProjectId" text="Project Id"></kendo-label>
            <kendo-textbox #osProjectId
                           formControlName="osProjectId"></kendo-textbox>
          </kendo-formfield>

          <kendo-formfield>
            <kendo-label [for]="osProjectNumber" text="Project Number"></kendo-label>
            <kendo-textbox #osProjectNumber
                           formControlName="osProjectNumber"></kendo-textbox>
          </kendo-formfield>

          <kendo-formfield>
            <kendo-label [for]="osProjectName" text="Project Name"></kendo-label>
            <kendo-textbox #osProjectName
                           formControlName="osProjectName"></kendo-textbox>
          </kendo-formfield>

          <kendo-formfield>
            <kendo-label [for]="osContractId" text="Contract Id"></kendo-label>
            <kendo-textbox #osContractId
                           formControlName="osContractId"></kendo-textbox>
          </kendo-formfield>

          <kendo-formfield>
            <kendo-label [for]="osOpportunityId" text="Opportunity Id"></kendo-label>
            <kendo-textbox #osOpportunityId
                           formControlName="osOpportunityId"></kendo-textbox>
          </kendo-formfield>

        </ng-template>
      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab [title]="'Environment settings'">
        <ng-template kendoTabContent>

          <kendo-formfield>
            <kendo-label [for]="extLicenseId" text="Parent License Id"></kendo-label>
            <kendo-textbox #extLicenseId
                           formControlName="extLicenseId"></kendo-textbox>
          </kendo-formfield>

          <kendo-formfield>
            <kendo-label [for]="lastModifiedOn" text="Last Modified On"></kendo-label>
            <kendo-datepicker #lastModifiedOn
                              formControlName="lastModifiedOn"
                              format="dd MMM yyyy">
            </kendo-datepicker>
          </kendo-formfield>

          <kendo-formfield>
            <kendo-label [for]="lastModifiedByName" text="Last Modified By"></kendo-label>
            <kendo-textbox #lastModifiedByName
                           formControlName="lastModifiedByName"
                           [readonly]="true"></kendo-textbox>
          </kendo-formfield>

        </ng-template>
      </kendo-tabstrip-tab>

    </kendo-tabstrip>
  </form>

  <kendo-dialog-actions *ngIf="!isReadOnlyCustomControl">
    <button kendoButton
            themeColor="primary"
            [disabled]="!editForm.valid"
            (click)="onSave($event)">
      {{ isNew ? 'Save' : 'Update' }}
    </button>
    <button kendoButton (click)="onCancel($event)">Cancel</button>

  </kendo-dialog-actions>

</kendo-dialog>
